module.exports = __webpack_public_path__ + "img/qcode_small.18a13541.jpg";